import styled from 'styled-components'

const TabHeaderPlato = styled.div`
  display: flex;
  flex-direction: column;

  .tabs {
    margin: 0 0.625em;
    padding-bottom: 0.75em;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
`

export default TabHeaderPlato
